import React from "react";
import undangresepsi from "../../img/undangresepsi.png";
import todo from "../../img/todolist.png";
import quran from "../../img/quran.png";
import personal from "../../img/profile2.png";
import mubin from "../../img/mubin.png";
import orang from "../../img/orang.png";
import { Disclosure } from "@headlessui/react";
import coretbin from "../../img/coretbin.png";
import "./embed.css";
import Footer from "../Footer";
import { Link } from "react-router-dom";

function ListKarya() {
  return (
    <ul className="mt-5">
      <li class="mb-5 ml-0 md:ml-6">
        <button className="flex items-center underline underline-offset-4 decoration-4 decoration-sky-500">
          <img
            src={undangresepsi}
            alt="undangresepsi"
            className="w-6 h-6 mr-2"
          />
          <a href="https://mubin-mhd.github.io/undangresepsi/">
            <h3 class="flex text-left items-center mb-2 text-lg md-text-xl font-semibold text-slate-700 dark:text-gray-200">
              UndangResepsi
            </h3>
          </a>
        </button>
        <p class="mb-4 text-lg md:text-xl font-normal text-slate-600 dark:text-gray-200">
          Undangan digital format video dibuat dengan reactJs, TailwindCSS, dan
          SASS
        </p>
      </li>
      <li class="mb-5 ml-0 md:ml-6">
        <button className="flex items-center underline underline-offset-4 decoration-4 decoration-sky-500">
          <img src={todo} alt="todolist" className="w-6 h-6 mr-2" />
          <a href="https://mubin-mhd.github.io/todolist/">
            <h3 class="flex text-left items-center mb-2 text-lg md-text-xl font-semibold text-slate-700 dark:text-gray-200">
              binTodo
            </h3>
          </a>
        </button>
        <p class="mb-4 text-lg md:text-xl font-normal text-slate-600 dark:text-gray-200">
          Catatan kegiatan harian untuk produktivitas dengan fitur CRUD & live
          time
        </p>
      </li>
      <li class="mb-5 ml-0 md:ml-6">
        <Disclosure>
          <Disclosure.Button className="flex items-center relative">
            <img src={quran} alt="quran" className="w-6 h-6 mr-2" />
            <h3 class="flex text-left items-center mb-2 text-lg md-text-xl font-semibold text-slate-700 dark:text-gray-200 underline underline-offset-4 decoration-4 decoration-sky-500">
              Digital Quran
            </h3>
            <mark className="bg-pink-500 text-white rounded-xl -mt-5 -ml-1 text-[12px] px-1 scale-75 font-semibold ">
              demo video
            </mark>
          </Disclosure.Button>
          <p class="mb-4 text-lg md:text-xl font-normal text-slate-600 dark:text-gray-200">
            Kumpulan ayat Al-Quran 30 juz lengkap dengan terjemahan, tafsir, dan
            audio (/surah)
          </p>
          <Disclosure.Panel className="text-gray-500 dark:text-gray-200 mt-5">
            <div className="videowrapper mb-5">
              <iframe
                src="https://www.youtube.com/embed/KubOvkh9uFA?rel=0&amp;controls=0"
                title="YouTube video player"
                frameborder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowfullscreen
              ></iframe>
            </div>
            Project ini masih di local (not deploy) sebagai gambaran disertakan
            video demo.{" "}
            <a
              className="underline underline-offset-2 decoration-2 decoration-sky-500"
              href="https://github.com/mubin-mhd/quran"
            >
              Link Github disini
            </a>
          </Disclosure.Panel>
        </Disclosure>
      </li>

      <li class="mb-5 ml-0 md:ml-6">
        <Disclosure>
          <Disclosure.Button className="flex items-center ">
            <img src={coretbin} alt="coretbin" className="w-6 h-6 mr-2" />
            <h3 class="flex text-left items-center mb-2 text-lg md-text-xl font-semibold text-slate-700 dark:text-gray-200 underline underline-offset-4 decoration-4 decoration-sky-500">
              Coretbin
            </h3>
            <mark className="bg-pink-500 text-white rounded-xl -mt-5 -ml-1 text-[12px] px-1 scale-75 font-semibold">
              demo video
            </mark>
          </Disclosure.Button>
          <p class="mb-4 text-lg md:text-xl font-normal text-slate-600 dark:text-gray-200">
            Blog pribadi tempat mencoret coret atau menulis sesuatu yang ingin
            ditulis
          </p>
          <Disclosure.Panel className="text-gray-500 dark:text-gray-200 mt-5">
            <div className="videowrapper mb-5">
              <iframe
                src="https://www.youtube.com/embed/UDRMlyhs2ko?rel=0&amp;controls=0"
                title="YouTube video player"
                frameborder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowfullscreen
              ></iframe>
            </div>
            Project ini masih di local (not deploy) sebagai gambaran disertakan
            video demo.{" "}
            <a
              className="underline underline-offset-2 decoration-2 decoration-sky-500"
              href="https://github.com/mubin-mhd/coretbin"
            >
              Link Github disini
            </a>
          </Disclosure.Panel>
        </Disclosure>
      </li>

      <li class="mb-5 ml-0 md:ml-6">
        <button className="flex items-center underline underline-offset-4 decoration-4 decoration-sky-500">
          <img src={personal} alt="personal" className="w-6 h-6 mr-2" />
          <a href="https://binadmin.netlify.app">
            <h3 class="flex text-left items-center mb-2 text-lg md-text-xl font-semibold text-slate-700 dark:text-gray-200">
              binadmin
            </h3>
          </a>
        </button>
        <p class="mb-4 text-lg md:text-xl font-normal text-slate-600 dark:text-gray-200">
          Portfolio pribadi dengan backend contentful
        </p>
      </li>

      <li class="mb-5 ml-0 md:ml-6">
        <button className="flex items-center underline underline-offset-4 decoration-4 decoration-sky-500">
          <img src={orang} alt="orang" className="w-6 h-6 mr-2" />
          <a href="https://mubin-mhd.github.io/mrmentor/">
            <h3 class="flex text-left items-center mb-2 text-lg md-text-xl font-semibold text-slate-700 dark:text-gray-200">
              Mr.Mentor
            </h3>
          </a>
        </button>
        <p class="mb-4 text-lg md:text-xl font-normal text-slate-600 dark:text-gray-200">
          Slicing Landing page (figma) ke static web (TailwindCSS)
        </p>
      </li>
      <li class="mb-5 ml-0 md:ml-6">
        <button className="flex items-center underline underline-offset-4 decoration-4 decoration-sky-500">
          <img src={mubin} alt="quran" className="w-6 h-6 mr-2" />
          <a href="https://mubin-mhd.github.io/profilestatic/">
            <h3 class="flex text-left items-center mb-2 text-lg md-text-xl font-semibold text-slate-700 dark:text-gray-200">
              Personal Web
            </h3>
          </a>
        </button>
        <p class="mb-6 text-lg md:text-xl font-normal text-slate-600  dark:text-gray-200">
          Personal web static dengan bootstrap
        </p>
        <Link to="/motivasi" className="dark:text-gray-200">
          👉
          <span className="text-slate-700 dark:text-gray-200 underline underline-offset-2 decoration-2 decoration-sky-500">
            motivasi
          </span>{" "}
          Yang membuat saya semangat
        </Link>
      </li>
      <Footer />
    </ul>
  );
}

export default ListKarya;
